import { render, staticRenderFns } from "./AddRepair.vue?vue&type=template&id=f2c07842"
import script from "./AddRepair.vue?vue&type=script&lang=js"
export * from "./AddRepair.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports